import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import {
  PaymentBaseAllBaseReadPaymentAllPaymentRead,
  PaymentBaseAllBaseWritePaymentAllPaymentWrite,
  PaymentService
} from '../openapi';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as fileSaver from 'file-saver';
import { getFileNameFromHttpResponse } from './helpers';

export interface RedirectData {
  url: string;
  postData: { hashtrans: string };
}

@Injectable({
  providedIn: 'root'
})
export class PaymentCommonService {
  constructor(
    private http: HttpClient,
    private paymentService: PaymentService
  ) {
  }

  private redirectToPaymentPage(data: RedirectData): void {
    const form: HTMLFormElement = document.createElement('form');
    form.method = 'post';
    form.action = data.url;
    form.style.visibility = 'hidden';
    const input: HTMLInputElement = document.createElement('input');
    input.type = 'text';
    input.name = Object.keys(data.postData)[0];
    input.value = data.postData.hashtrans;
    form.append(input);
    document.body.appendChild(form);
    form.submit();
  }

  private getRedirectData(payment: PaymentBaseAllBaseWritePaymentAllPaymentWrite): Observable<RedirectData> {
    return this.paymentService.purchasePaymentCollection({
      payment
    }).pipe(
      map(v => v as any),
      map(v => v as RedirectData)
    );
  }

  public goToPay(payment: PaymentBaseAllBaseWritePaymentAllPaymentWrite): Observable<any> {
    return this.getRedirectData(payment)
      .pipe(
        tap(v => this.redirectToPaymentPage(v))
      );
  }

  public loadPaymentInfo(payment_token: string): Observable<PaymentBaseAllBaseReadPaymentAllPaymentRead> {
    return this.http.post(`${environment.apiBasePath}/payments/done?payum_token=${payment_token}`, {}).pipe(
      tap({
        next: v => v,
        error: () => undefined
      })
    );
  }

  public downloadConfirmation(paymentId: string, name?: string): Observable<any> {
    return this.http.get(`${environment.apiBasePath}/payments/${paymentId}/confirmation`, {
      observe: 'response', responseType: 'blob'
    }).pipe(
      tap(result => {
        fileSaver.saveAs(result.body as any, name || getFileNameFromHttpResponse(result) || `Potwierdzenie-platnosci.pdf`);
      })
    );
  }
}
